import { Card } from "@material-ui/core"
import React from "react"

export function LoadingScreen(){
  return (
		<div>
			<Card>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
            height: 200
					}}
				>
					<div style={{
            fontSize: 20,
          }}>Loading .....</div>
				</div>
			</Card>
		</div>
	);
}